export class TicketAdminBookmark {
	public id:number = 0;
	public ticketId:number = 0;
	public adminId:number = 0;

	public constructor(data:any){
		this.id = data.id;
		this.ticketId = data.ticketId;
		this.adminId = data.adminId;
	}
}